import { useMutation } from '@apollo/client'
import { ActivatePasswordReset, ActivatePasswordResetVariables } from '../../types'
import { USER_DELETED } from '../userDeleted/operations'
import { ACTIVATE_USER } from './operations'

export const useActivatePasswordReset = (id: string) =>
  useMutation<ActivatePasswordReset, ActivatePasswordResetVariables>(ACTIVATE_USER, {
    refetchQueries: [
      {
        query: USER_DELETED,
        variables: { id }
      },
    ],
  })
